export const PATH_INBOX = '/';
export const PATH_INBOX_FLAGGED = '/flagged';
export const PATH_INBOX_COMPLETED = '/completed';
export const PATH_NEW_CASE = '/new';
export const PATH_NEW_CASE_FROM_XM = '/newehr';
export const PATH_READONLY_CASE = '/readonly';
export const PATH_EDIT_CASE = '/edit';
export const PATH_EDIT_CASE_BY_ID = '/cases/:id';
export const PATH_SETTINGS = '/settings';
